import React from 'react'
import s from './maincon.module.scss'

export default function MainContainer({ children }) {
    return (
        <div className={s.container}>
            {children}
        </div>
    )
}
